import { datasource } from './datasource';

export const ballDrilledDS = (databaseAlias, currentUserId, actions) => () =>
  datasource(databaseAlias, currentUserId, actions)('ball_drilled', {
    model: {
      id: 'id',
      auditable: true,
      syncable: true,
      autoSync: true,
      byProshop: true,
      //                byProshopSQL: 'SELECT t1.* FROM -tablename- AS t1, customer_proshop AS t2 WHERE t1.customer_id = t2.customer_id AND t2.proshop_id = "-proshopId-"',
      byProshopSQL:
        'SELECT t1.* FROM -tablename- AS t1, customer_proshop AS t2 WHERE t1.customer_id = t2.customer_id AND t1.customer_id="-customerId-"',
      getPhoto: function(data) {
        if ($.imageDirectoryReader && $.imageDirectoryReader.localURL && data && data.photo) {
          var filePathArray = data.photo.split('/');
          if (filePathArray.length > 0) {
            var fileName = filePathArray[filePathArray.length - 1];
            return $.imageDirectoryReader.localURL + fileName;
          } else {
            return '';
          }
        } else if ($.imageDirectoryReader && !$.imageDirectoryReader.localURL && data && data.photo) {
          return data.photo.replace('cdvfile:', 'electronfile:');
          //                             let userDataPath = window.require('electron').remote.getGlobal('appDataPath');
          //                             let path = window.require('path');
          //
          //                             return `file://${path.normalize(data.photo.replace('cdvfile://localhost/persistent/', `${path.normalize(userDataPath)}/`))}`;
        } else {
          return '';
        }
      },
      fields: {
        id: {
          type: 'string',
        },
        customer_id: {
          type: 'string',
        },
        ball_name: {
          type: 'string',
        },
        manufacturer: {
          type: 'string',
        },
        date_drilled: {
          type: 'string',
        },
        drilling_angle: {
          type: 'string',
          calculated: true,
        },
        pin_to_pap: {
          type: 'string',
          calculated: true,
        },
        val_angle: {
          type: 'string',
          calculated: true,
        },
        psa_to_pap: {
          type: 'string',
          calculated: true,
        },
        pin_buffer: {
          type: 'string',
          calculated: true,
        },
        layout: {
          type: 'string',
        },
        surface_preparation: {
          type: 'string',
        },
        weight: {
          type: 'string',
        },
        weight_hole_position: {
          type: 'string',
        },
        weight_hole_size: {
          type: 'string',
        },
        weight_hole_depth: {
          type: 'string',
        },
        spec_sheet_id: {
          type: 'string',
        },
        photo: {
          type: 'raw',
        },
        position: {
          type: 'number',
          alter: true,
        },
        enable: {
          type: 'boolean',
          default: true,
          alter: true,
        },
        created_at: {
          type: 'string',
        },
        updated_at: {
          type: 'string',
        },
        created_by: {
          type: 'string',
        },
        updated_by: {
          type: 'string',
        },
      },
    },
  });
